// extracted by mini-css-extract-plugin
export default {"cancel-btn":"AddQuestionnaireMainContainerStyle_cancel-btn__dMqrg","add-Questionnaire":"AddQuestionnaireMainContainerStyle_add-Questionnaire__VLo89"};